import { useTranslation } from 'react-i18next';
import { ManageRolesColumn } from './manageRolesColumns';

export interface ManageRolesTableHeadProps {
  columns: ManageRolesColumn[];
};

export const ManageRolesTableHead = (props: ManageRolesTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
};
